import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Alert } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';

import { renderField } from 'core/utils/form';
import { required, matchPwd } from 'core/utils/validations';
import './ResetPasswordForm.css';

const propTypes = {
  onSubmit: PropTypes.func.isRequired
};

class ResetPasswordForm extends React.Component {
  render() {
    const { error, handleSubmit, invalid, submitting } = this.props

    return (
      <div className="ResetPasswordForm">
        <div className="ResetPasswordForm__header">
          <h4>Reset Password</h4>
        </div>
        <Form onSubmit={handleSubmit} noValidate>
            {error && (<Alert color="danger">{error}</Alert>)}

            <Field
              name="password"
              error={error}
              component={renderField}
              type="password"
              placeholder="Password"
              validate={[required]}
            />

            <Field
              name="password_confirmation"
              error={error}
              component={renderField}
              type="password"
              placeholder="Password Confirmation"
              validate={[required, matchPwd]}
            />

            <Button
              color="primary"
              disabled={invalid || submitting}
            >Update</Button>
        </Form>
      </div>
    )
  }
}

ResetPasswordForm.propTypes = propTypes;

ResetPasswordForm = reduxForm({
  form: 'resetPassword'
})(ResetPasswordForm);

export default ResetPasswordForm;



// WEBPACK FOOTER //
// ./src/features/user/ResetPasswordContainer/ResetPasswordForm.js